module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/znamenka-a-kozni-vyrustky_4_after_tn.jpg
// module id = 1479
// module chunks = 0